import { useRef } from 'react'

import classNames from 'classnames'

import { useHorizontalDragScroll, useHorizontalOverflow } from '@app/hooks'

import { AttachmentListingCard } from './AttachmentListingCard'
import sharedStyles from '../styles.module.scss'
import styles from './styles.module.scss'
import type { MessageListingAttachmentsProps } from './types'

export const MessageListingAttachments = ({ items }: MessageListingAttachmentsProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const hasHorizontalOverflow = useHorizontalOverflow(containerRef, [items.length])

  useHorizontalDragScroll(containerRef, {
    disabled: !hasHorizontalOverflow,
  })

  if (!items.length) {
    return null
  }

  const containerClassName = classNames(sharedStyles.attachmentsWrapper, {
    [sharedStyles.dragEnabled]: hasHorizontalOverflow,
  })

  return (
    <div
      className={containerClassName}
      ref={containerRef}
    >
      <div className={styles.listingAttachments}>
        {items.map((item) => (
          <AttachmentListingCard
            key={`message-attachment-${item.id}`}
            cardData={item.cardData}
            listingLink={item.listingLink}
          />
        ))}
      </div>
    </div>
  )
}
